import type { ColumnConfig } from '@/components/datatable/dataTableTypes';

export const columns: ColumnConfig[] = [
  { field: 'id', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'contactPerson_firstName', hidden: true },
  { field: 'contactPerson_lastName', hidden: true },
  {
    field: 'name',
    combinedField: ['contactPerson_firstName', 'contactPerson_lastName'],
    template: 'concatString',
  },
  { field: 'role' },
  { field: 'jobTitle' },
  { field: 'version', hideInitial: true, align: 'center' },
];
